import React from 'react';
import { List, Typography } from 'antd';
import Icon from '@ant-design/icons';
import Image from 'components/Antd/Image/index';
import { ReactComponent as ShopIcon } from 'assets/icons/shop.svg';
import { ReactComponent as FactoryIcon } from 'assets/icons/factory.svg';

import classname from 'classnames';
import PropTypes from 'prop-types';
import classes from './Style.module.scss';

export default function ProductListItem({
  image,
  name,
  itemNo,
  supplier,
  factory,
  extra,
  children,
  className,
  bordered,
}) {
  return (
    <List.Item
      className={classname(classes.factory, className, {
        [classes.bordered]: bordered,
      })}>
      <div className={classes.card}>
        <List.Item.Meta
          avatar={
            <Image
              preview={false}
              width={80}
              height={40}
              src={image}
              style={{ objectFit: 'contain' }}
            />
          }
          title={
            <span className={classes.group}>
              <Typography.Title className={classes.title} level={5}>
                {name}
              </Typography.Title>
              <p className={classes.caption}>{itemNo}</p>
            </span>
          }
          description={
            <span className={classes.group}>
              <span className={classes.inline}>
                <Icon component={ShopIcon} />
                <p className={classes.caption}>{supplier}</p>
              </span>
              <span className={classes.inline}>
                <Icon component={FactoryIcon} />
                <p className={classes.caption}>{factory}</p>
              </span>
            </span>
          }
        />
        {extra}
      </div>
      {children}
    </List.Item>
  );
}
ProductListItem.propTypes = {
  image: PropTypes.string,
  itemNo: PropTypes.string,
  supplier: PropTypes.string,
  name: PropTypes.string.isRequired,
  bordered: PropTypes.bool,
  extra: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  factory: PropTypes.string,
};

ProductListItem.defaultProps = {
  bordered: true,
  extra: null,
  children: null,
  className: '',
  itemNo: '',
  image: '',
  supplier: '',
  factory: '',
};
